var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Effect, Actions } from '@ngrx/effects';
import * as managerAction from '../actions/manager.action';
import { switchMap, mergeMap, withLatestFrom, filter } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import { isNullOrUndefined } from 'util';
import { FreelancersService } from '../../../freelancers/freelancers.service';
import { ManagersService } from '../../managers.service';
var ManagerEffect = /** @class */ (function () {
    function ManagerEffect(actions, managerService, freelancerService, store) {
        var _this = this;
        this.actions = actions;
        this.managerService = managerService;
        this.freelancerService = freelancerService;
        this.store = store;
        this.getAllManagers = this.actions.ofType(managerAction.GET_ALL_MANAGERS)
            .pipe(switchMap(function () {
            return _this.managerService.getAllManagers()
                .map(function (res) { return new managerAction.GetAllManagersSuccess(res); })
                .catch(function (error) { return of(new managerAction.GetAllManagersError(error)); });
        }));
        this.getManager = this.actions.ofType(managerAction.GET_MANAGER)
            .pipe(withLatestFrom(
        // select users.
        this.store.select(function (state) { return state.managersFeature.managers.users; }), function (action, users) {
            // if no users present, proceed for API.
            if (isNullOrUndefined(users)) {
                return action;
            }
            else {
                // users exists in store.
                var manager = users.filter(function (m) { return m.id === action.payload; })[0];
                if (!!manager) {
                    // if required user is present in store, then return;
                    return undefined;
                }
                else {
                    // if required user not present in store, then proceed for API.
                    return action;
                }
            }
        }), filter(function (action) { return !!action; }), mergeMap(function (action) {
            return _this.freelancerService.getFreelancer(action.payload)
                .map(function (res) { return new managerAction.GetManagerSuccess(res); })
                .catch(function (error) { return of(new managerAction.GetManagerError(error)); });
        }));
        // .pipe(
        //   switchMap((freelancerId) => {
        //     return new managerAction.GetManager(freelancerId);
        //     // return this.managerService.getManager(freelancerId)
        //     //   .map(res => new managerAction.GetManagerSuccess(res))
        //     //   .catch(error => of(new managerAction.GetManagerError(error)));
        //   })
        // );
        this.registerManager = this.actions.ofType(managerAction.ADD_MANAGER)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.freelancerService.registerFreelancer(body)
                .map(function (res) { return new managerAction.AddManagerSuccess(res); })
                .catch(function (error) { return of(new managerAction.AddManagerError(error)); });
        }));
        this.updateManager = this.actions.ofType(managerAction.UPDATE_MANAGER)
            .map(function (action) { return action.payload; })
            .pipe(switchMap(function (body) {
            return _this.freelancerService.updateFreelancer(body)
                .map(function (res) { return new managerAction.UpdateManagerSuccess(res); })
                .catch(function (error) { return of(new managerAction.UpdateManagerError(error)); });
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ManagerEffect.prototype, "getAllManagers", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ManagerEffect.prototype, "getManager", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ManagerEffect.prototype, "registerManager", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Observable)
    ], ManagerEffect.prototype, "updateManager", void 0);
    return ManagerEffect;
}());
export { ManagerEffect };



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/store/effects/manager.effect.ts.pre-build-optimizer.js